import React from 'react';
import './Ticket.css';
import AmbientStage from '../components/AmbientStage';
import BottomNav from '../components/BottomNav';
import RotatingDisc from '../components/RotatingDisc';
import MobileTicker from '../components/MobileTicker';
import logo from '../assets/logo.png';

const accessItems = ['Hall A-C', 'Live demos', 'Buyer lounge'];

function Ticket({ activeScreen, onNavigate }) {
  return (
    <AmbientStage className="ticket-screen">
      <header className="ticket-header">
        <div>
          <p className="eyebrow">Digital Ticket</p>
          <h2>Your pass is live.</h2>
        </div>
        <button className="ticket-close" onClick={() => onNavigate('Home')} type="button">Home</button>
      </header>

      <section className="digital-ticket" aria-label="Digital exhibition ticket">
        <div className="ticket-top">
          <img src={logo} alt="Exhibition logo" />
          <div>
            <span>Visitor Pass</span>
            <strong>Textile Future 26</strong>
          </div>
        </div>

        <div className="ticket-main">
          <p>Egypt International Exhibition for Garment & Textile Machinery</p>
          <h1>Lamar Shehab</h1>
          <div className="ticket-meta">
            <span>20 Apr 2026</span>
            <span>06:30 PM</span>
            <span>Cairo</span>
          </div>
        </div>

        <div className="qr-panel" aria-label="Ticket QR code">
          <div className="fake-qr">
            {[...Array(25)].map((_, index) => (
              <span key={index} />
            ))}
          </div>
          <RotatingDisc label="Scan" detail="Gate 04" />
        </div>

        <div className="ticket-number">
          <span>Ticket ID</span>
          <strong>EGX-26-0148</strong>
        </div>
      </section>

      <MobileTicker />

      <section className="ticket-access" aria-label="Included access">
        {accessItems.map((item, index) => (
          <article key={item}>
            <span>0{index + 1}</span>
            <p>{item}</p>
          </article>
        ))}
      </section>

      <BottomNav activeScreen={activeScreen} onNavigate={onNavigate} />
    </AmbientStage>
  );
}

export default Ticket;
